export const timeFromMinutes = (time: number) => {
  const hh = Math.floor(time / 60);
  const mm = time % 60;
  return `${hh}h${mm ? (mm < 10 ? `0${mm}` : mm) : ''}`
}

export const secondsToTime = (time: number) => {
  const h = Math.floor(time / 60);
  const m = time % 60;

  return `${h}h${m > 10 ? m : `0${m}`}`
}
